import { colorThresholds } from '@/root/shared-consts'

const { GREEN_PERCENT, YELLOW_PERCENT, MIN_PERCENT } = colorThresholds

export type AvailabilityLevel = 'green' | 'yellow' | 'red'

export interface AvailabilityGauge {
  /** Percentage clamped to [MIN_PERCENT, 100]: a tiny arc stays visible, an overshoot cannot break the gauge. */
  displayPercent: number
  /** Availability tier: green (plenty), yellow (limited), red (scarce/none). */
  level: AvailabilityLevel
  /** Actual availability percentage (rounded), used to pick the level. */
  percent: number
}

/**
 * Derives the availability gauge model (percentage + colour tier) from raw amount/total.
 * When total is 0 or negative it is treated as 100 so the percentage stays finite.
 */
export const getAvailabilityLevel = (amount: number, total: number): AvailabilityGauge => {
  const safeTotal = total > 0 ? total : 100
  const percent = Math.round((amount / safeTotal) * 100)
  const displayPercent = Math.min(Math.max(percent, MIN_PERCENT), 100)

  const level: AvailabilityLevel = percent >= GREEN_PERCENT ? 'green' : percent >= YELLOW_PERCENT ? 'yellow' : 'red'

  return { percent, level, displayPercent }
}
